export const KYC_PERSONAL_INFO_KEY = 'kycPersonalInfo'
export const KYC_ADDRESS_INFO_KEY = 'kycAddressInfo'
